import { cloneDeep } from 'lodash';
import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { isHttpUri } from '@/utils/file-kit';
import { getOrCreateScreenshotUrlCode, hydrateScreenshotUrlCode } from '@/utils/screenshot-url-kit';
import type { IChartLayer } from '@/version-types';

export const getChartScreenshotFingerprintData = (layer: IChartLayer, locale: string) => {
    const data = cloneDeep(layer.data);
    delete data.screenshotUrl;

    return {
        width: Math.floor(layer.width),
        height: Math.floor(layer.height),
        ...(data.chartData.length === 0 ? { locale } : {}),
        ...data,
    };
};

export const hydrateChartLayerScreenshotUrl = (layer: IChartLayer, locale: string) => {
    layer.data.screenshotUrl = hydrateScreenshotUrlCode({
        fingerprintData: getChartScreenshotFingerprintData(layer, locale),
        remoteUrl: layer.data.screenshotUrl,
    });
    return layer;
};

export const initializeChartLayerScreenshotUrl = (layer: IChartLayer, locale: string) => {
    if (!layer.__runtime?.isInit && layer.data.screenshotUrl && isHttpUri(layer.data.screenshotUrl)) {
        hydrateChartLayerScreenshotUrl(layer, locale);
    }
    layer.__runtime = {
        ...layer.__runtime,
        isInit: true,
    };
    return layer;
};

/**
 * 获取图表缩略图 Code
 * @param identity - 编辑器实例 ID
 * @param layer - 图表图层
 */
export const getChartLayerScreenshotUrlCode = async (identity: string, layer: IChartLayer) => {
    if (layer.width <= 0 || layer.height <= 0) return '';

    return getOrCreateScreenshotUrlCode({
        fingerprintData: getChartScreenshotFingerprintData(layer, getLocaleStore().locale),
        createDataUrl: async () => {
            const canvas = await getFramework(identity).service.behavior.get(layer)?.getLayerImageAsync?.(layer, false);
            return canvas?.toDataURL();
        },
    });
};
